import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ThemeService } from './core/services/utils/theme.service';
import { LanguageService } from './core/services/utils/language.service';
import { AgeTierService } from './core/services/utils/age-tier.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit {
  constructor(
    private themeService: ThemeService,
    private languageService: LanguageService,
    private ageTierService: AgeTierService,
  ) {
    // Load dark/light theme from localStorage
    this.themeService.loadInitialTheme();

    // Apply initial language and direction
    this.languageService.loadInitialLanguage();

    // Apply initial age tier (primaire/college/lycee) — drives visual style
    this.ageTierService.loadInitialTier();
  }

  ngOnInit(): void {
    // No need for manual language handling here anymore
  }
}
